var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-simple-upload',{staticClass:"site-logo-upload",attrs:{"show-upload-button":false,"text":_vm.text},on:{"change":_vm.changeLogo}})
}
var staticRenderFns = []

export { render, staticRenderFns }